import React from 'react';
import { Menu, MenuItem } from '@mui/material';

import { getAnchorProps, MenuAnchor } from '@paragon/client-tools';
import { AssemblyGroup } from '@paragon/contract-library';
import { hasSupervisorFeatureFlag } from '@paragon/login-tools';

import { editAssemblyGroup } from '../../../actions/assemblyGroupActions';
import { showEditAssemblyGroupPropertiesDialog, showSendAssemblyGroupDialog } from '../../../actions/dialogActions';
import { useNavigateIfNeeded } from '../../../util/useNavigateIfNeeded';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ASSEMBLY_GROUPS_URL_SLUG } from '../../url-slugs';

export function AssemblyGroupMenu(props: { assemblyGroup: AssemblyGroup; anchor: MenuAnchor; onClose: () => void }) {
  const { anchor, assemblyGroup } = props;
  const dispatch = useAppDispatch();
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);

  const navigate = useNavigateIfNeeded();

  return (
    <Menu open={anchor != null} {...getAnchorProps(anchor)} onClose={props.onClose}>
      {isSupervisor && [
        <MenuItem
          key="edit-properties"
          onClick={() => {
            props.onClose();
            dispatch(showEditAssemblyGroupPropertiesDialog(assemblyGroup.guid));
          }}
        >
          Edit Properties
        </MenuItem>,
        <MenuItem
          key="archive"
          onClick={() => {
            props.onClose();
            dispatch(editAssemblyGroup(assemblyGroup.guid, { archived: true }));
          }}
        >
          Archive
        </MenuItem>,
        <MenuItem
          key="send-to-line-or-station"
          onClick={() => {
            props.onClose();
            dispatch(showSendAssemblyGroupDialog(assemblyGroup.guid));
          }}
        >
          Send to Lines/Stations
        </MenuItem>,
      ]}
      <MenuItem
        onClick={() => {
          props.onClose();
          navigate(`/${ASSEMBLY_GROUPS_URL_SLUG}/${assemblyGroup.guid}`);
        }}
      >
        View
      </MenuItem>
    </Menu>
  );
}
